import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';

import * as _ from 'lodash';

import { HttpService } from '../../core/http/http.service';
import { PopoverInput } from './base/popover-input';

@Component({
	selector: 'popover-checkbox-list',
	template: require('./popover-checkbox-list.component.html')
})
export class PopoverCheckboxListComponent extends PopoverInput implements OnChanges {

	constructor(private httpService: HttpService) { super() }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['originalValue']) {
			this.dirtyValue = changes['originalValue'].currentValue;
        }
	}

	originalValue: any[];

	dirtyValue: any[];

	@Input() items: any[];

	@Input('itemsUrl')
	set itemsUrl(url: string) {
		this.httpService.get<any[]>(url).then(result => this.items = result);
	};


	@Input('value')
	set setValue(val: any) {
		console.log("setting tag value");
		this.originalValue = val;
		this.dirtyValue = Array.from(val);

	}

	getText(i: number) {
		var itm = this.items.find(x => x[this.valueField] === i);

		if (!itm)
			return "??";

		return itm[this.textField];
	}


	@Input() valueField: string = "id";
	@Input() textField: string = "name";

	onChange(item, $event) {

		if (this.dirtyValue) {
			if ($event.target.checked && this.dirtyValue.indexOf(item[this.valueField] == -1)) {
				this.dirtyValue.push(item[this.valueField]);
			} else {
				this.dirtyValue = this.dirtyValue.filter(x => x !== item[this.valueField]);
			}
		} else {
			console.warn("There is no array to modify!");
		}


		console.dir(this.dirtyValue);

	}


	get hasChanges() {

		if (!this.dirtyValue)
			return false;

		const arraysSame = (this.dirtyValue.length === this.originalValue.length) &&
			(this.dirtyValue.length === _.intersection(this.dirtyValue, this.originalValue).length);

		return !arraysSame;
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-checkbox-list.component.ts